import { motion, useReducedMotion } from "framer-motion";
import { MOTION, REVEAL_VARIANTS } from "./config";

export function ScrollReveal({ children, variant = "up", delay = 0, duration = MOTION.duration.reveal, className = "", as = "div", ...rest }) {
  const reduced = useReducedMotion();
  const Comp = motion[as] || motion.div;
  const v = reduced ? REVEAL_VARIANTS.fade : REVEAL_VARIANTS[variant] || REVEAL_VARIANTS.up;
  return (
    <Comp initial="hidden" whileInView="show" viewport={MOTION.viewport} variants={v} transition={{ duration: reduced ? 0.3 : duration, delay, ease: MOTION.ease.premium }} className={className} {...rest}>
      {children}
    </Comp>
  );
}

export function StaggerReveal({ children, variant = "up", stagger = MOTION.stagger.cards, className = "", ...rest }) {
  const reduced = useReducedMotion();
  const child = reduced ? REVEAL_VARIANTS.fade : REVEAL_VARIANTS[variant] || REVEAL_VARIANTS.up;
  const kids = Array.isArray(children) ? children : [children];
  return (
    <div className={className} {...rest}>
      {kids.map((c, i) => c && (
        <motion.div key={c.key ?? i} initial="hidden" whileInView="show" viewport={MOTION.viewport} variants={child}
          transition={{ duration: MOTION.duration.standard, ease: MOTION.ease.premium, delay: reduced ? 0 : Math.min(i % 4, 3) * stagger }}>
          {c}
        </motion.div>
      ))}
    </div>
  );
}

export function TextReveal({ lines = [], className = "", lineClassName = "", as = "h1", delay = 0, immediate = true }) {
  const reduced = useReducedMotion();
  const Comp = motion[as] || motion.h1;
  const inView = immediate ? { animate: "show" } : { whileInView: "show", viewport: MOTION.viewport };
  return (
    <Comp className={className} initial="hidden" {...inView} variants={{ hidden: {}, show: { transition: { staggerChildren: reduced ? 0 : MOTION.stagger.lines, delayChildren: delay } } }}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span className={`block ${lineClassName}`} variants={reduced ? REVEAL_VARIANTS.fade : REVEAL_VARIANTS.blur} transition={{ duration: MOTION.duration.hero * 0.8, ease: MOTION.ease.premium }}>{line}</motion.span>
        </span>
      ))}
    </Comp>
  );
}
